import { Component } from '@theme/component';

class VideoWithTimedProducts extends Component {
    static observedAttributes = [];
    requiredRefs = ["syncedVideo","syncedProducts"];
    #syncedVideo=null;
    #syncedVideoPlayer=null;
    #syncedProducts=null;
    #observer=null;
    #pause=false;
    constructor() {
        super();
    }
    #handleTimeUpdate=(e)=>{
      if(this.#pause) return;
     // console.log(this.#syncedVideoPlayer.currentTime);
        const event = new CustomEvent('timeupdate',{
            detail: { timestamp: this.#syncedVideoPlayer.currentTime }
        });
        this.dispatchEvent(event);
    }
    #getVideoElement(){
      return this.#syncedVideo.querySelector("video-with-timed-products video")||null;
    }
    #handleObservation(mutationsList, observer){
      var foundvideo=null
      for (const mutation of mutationsList) {
        let target = mutation.target;
        if (mutation.type === "childList") {
            for (const node of mutation.addedNodes) {
              if (!node.tagName) continue; // not an element
              if (node.tagName=="VIDEO") {
                foundvideo=node;
                
                observer.disconnect();
              } 
            }
        }
      }
      if(foundvideo) foundvideo.closest("video-with-timed-products").#videoInitialise();
    }
    #videoInitialise(){
       const config = { attributes: false, childList: true, subtree: false };
      if(this.#syncedVideoPlayer)return;
      this.#syncedVideoPlayer=this.#getVideoElement();
      if(!this.#syncedVideoPlayer){
        this.#observer = new MutationObserver(this.#handleObservation);
        this.#observer.observe(this.#syncedVideo, config);
      }else{
        this.#syncedVideoPlayer.addEventListener("timeupdate", (event) => { 
          this.#handleTimeUpdate(event)
        });   
      }
    }
    #setStartTimes=()=>{
      const timedProducts=this.#syncedProducts.querySelectorAll("timed-product");
      var start=0;
      for(const timedProduct of timedProducts){
          const duration= parseInt(timedProduct.getAttribute('duration')||"0");
          timedProduct.setAttribute('start',start);
          start+=duration;
          timedProduct.setAttribute('end',start);
      }
    }
    #setPause=()=>{
      this.#pause=true   
     }
    #setStart=()=>{
      this.#pause=false
    }
    connectedCallback() {
      //console.log("video with timed product")
     
       super.connectedCallback();
        this.#syncedVideo= this.refs.syncedVideo;
        this.#syncedProducts= this.refs.syncedProducts;
        //console.log(this.#syncedVideo);
        this.#videoInitialise();
        this.#setStartTimes();
        this.#syncedProducts.addEventListener("mouseover", (event) => { 
          this.#setPause();
        });
         this.#syncedProducts.addEventListener("mouseout", (event) => { 
          this.#setStart();
        });
    }

    disconnectedCallback() {
    // Disconnect all the event listeners
 
    }
  
    attributeChangedCallback(name, oldValue, newValue) {
      
    }

}


class TimedProduct extends Component {
    static observedAttributes = ["start","end"];
    requiredRefs = [];
    #controlParent=null;
    #slideshowComponent=null;
    #slide=null;
    #startTime=null;
    #endTime=null;
    #mySlideId=null;
    #checkMyTime=(currentTime)=>{
      if(this.#startTime===null || this.#endTime===null ) return;
      if(currentTime<this.#startTime) return;
      if(currentTime>this.#endTime) return;
      //console.log(`it is my time ${this.#mySlideId} :)`)
      this.#showMe();
    }
    #showMe=()=>{
     // console.log(`it is my time ${this.#mySlideId} :) you can't see me ${this.#slide.ariaHidden}`)
      
      if(this.#slide.ariaHidden){
       // console.log("here i am")
          this.#slideshowComponent.select({"id":this.#mySlideId}, null,{});
      } 
    }
    connectedCallback() {
     // console.log("timed product")
  
      this.#controlParent=this.closest("video-with-timed-products");     
      if(!this.#controlParent) return;
  
      this.#slideshowComponent=this.closest("slideshow-component");  
      if(!this.#slideshowComponent) return;
      this.#slide=this.closest("slideshow-slide");
      
      if(!this.#slide) return;
      this.#mySlideId=this.#slide.getAttribute("slide-id");
      this.#controlParent.addEventListener('timeupdate', (e) => {
            this.#checkMyTime(e.detail.timestamp);
      });
      
    }

    disconnectedCallback() {
    // Disconnect all the event listeners
 
    }
  
    attributeChangedCallback(name, oldValue, newValue) {
      if(name==="start"){
        this.#startTime=parseInt(newValue)/1000;
      }
      if(name==="end"){
        this.#endTime=parseInt(newValue)/1000;
      }
    }
  }
  if (!customElements.get('video-with-timed-products')) {
    customElements.define('video-with-timed-products', VideoWithTimedProducts);
  }
  if (!customElements.get('timed-product')) {
    customElements.define('timed-product', TimedProduct);
  }